import { AccessPermissions } from '@circlefin/permissions'
import { Role } from '@circlefin/permissions/roles'
import { SynthRole } from '@services/synthetic-roles'

import type { PermissionSet } from '@circlefin/permissions'

/**
 * Permission to sign Cross Currency API agreement.
 */
export const SIGN_CROSS_CURRENCY_API_ROLE: PermissionSet = {
  access: AccessPermissions.protected,
  includeAll: [
    SynthRole.SYNTH_MSA_API_ACCESS_ROLE, // FS must be enabled
    Role.CREATE_API_KEY_ROLE, // Must have signed core api agreement
    Role.DEVELOPER_ROLE, // Must be an admin
  ],
  excludeAny: [Role.CROSS_CURRENCY_API_ROLE], // Cannot have signed cross currency api already
}
